import { Button, Flex } from '@landsbankinn/ui-kit';
import { useScreenSize } from 'src/hooks/useScreenSize';

export function FooterWithButtons(props: {
  previousTitle: string;
  nextTitle: string;
  isConfirm?: boolean;
  disabled?: boolean;
  hideNext?: boolean;
  onPrevious: () => void;
  onNext: () => void;
}) {
  const { isMobile } = useScreenSize();
  return (
    <Flex
      marginTop="56"
      paddingTop="58"
      paddingBottom="56"
      borderTop={isMobile ? 'none' : 'regular 30'}
      background="blue baseLight"
      mainAxisAlignment={isMobile ? 'center' : 'space between'}
      rowGap={isMobile ? '24' : undefined}
      colGap="30"
      wrap={isMobile ? 'wrap' : 'no wrap'}
    >
      <Button
        variant="secondary"
        width="100%"
        onClick={() => {
          props.onPrevious();
        }}
      >
        {props.previousTitle}
      </Button>
      {!props.hideNext && (
        <Button
          variant="submit"
          width="100%"
          disabled={props.disabled}
          onClick={() => {
            props.onNext();
          }}
        >
          {props.nextTitle}
        </Button>
      )}
    </Flex>
  );
}
